<template>
  <v-container
    id="enrollerEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Enroller"
          item-text="fullName"
          item-value="enrollerId"
          bind-text="fullName"
          bind-value="enrollerId"
          :bind-item="editedItem"
          :error-messages="safeFormErrors.EnrollerId"
          :fetch-method="getFromEnrollerDetail"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'EnrollerEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,

      oeEnrollerDetailEligibilityResource: new TroodyApi('oeEnrollerDetailEligibility/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = this.value
      },

      getFromEnrollerDetail () {
        const query = {
          openEnrollmentId: this.openEnrollment.id,
          brokerId: this.openEnrollment.brokerId,
        }
        return this.oeEnrollerDetailEligibilityResource.query(query)
      },

      transformItem () {
        this.editedItem.openEnrollmentId = this.openEnrollment.id

        return this.editedItem
      },

      onChange () {
        this.transformItem()
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
